import api from "./api";
import qsStringify from "./qsStringify";

export const getJobSeekers = locale => {
  const query = qsStringify({
    locale,
    populate: [
      "page_info",
      "page_info.seo_info",
      "page_info.seo_info.image",
      "page_info.banner",
    ],
  });

  return api.get(`/page-job-seekers?${query}`).then(res => res.data);
};

export const getJobPositionsPage = locale => {
  const query = qsStringify({
    locale,
    populate: ["page_info.seo_info.image", "page_info.banner"],
  });

  return api.get(`/page-job-position?${query}`).then(res => res.data);
};

export const getJobPositions = locale => {
  const query = qsStringify({
    locale,
    populate: ["jobs"],
  });

  return api.get(`/api-job-positions?${query}`).then(res => res.data);
};
